import React, { Suspense } from 'react'
import { Navigate, Route, RouterProvider, createRoutesFromElements } from 'react-router-dom'
import { createBrowserRouter } from 'react-router-dom'
import 'simplebar-react/dist/simplebar.min.css'
import Cookies from 'universal-cookie'

import { RequireAuth } from '@components/RequireAuth'
import { AuthLayout } from '@components/layouts/AuthLayout'
import { BaseLayout } from '@components/layouts/BaseLayout'
import { EmptyLayout } from '@components/layouts/EmptyLayout'

import { Loader } from '@UI/Loader'

import { useActions } from '@hooks/useActions'

import routes, { finishStaffRegisterRoutes, lessonLayoutRoutes, registerRoutes, signInRoute, statusesRoutes } from '@assets/constants/routes'
import type { Route as RouteType } from '@assets/types/globals'

const renderRoutes = (routesArr: RouteType[], requireAuth: boolean) =>
  routesArr.map((i) => (
    <Route
      key={i.title}
      path={i.rootPath}
    >
      {i.list.map((j) => (
        <Route
          key={j.path}
          path={j.path}
          element={<Suspense fallback={<Loader />}>{requireAuth ? <RequireAuth>{j.element}</RequireAuth> : j.element}</Suspense>}
        />
      ))}
    </Route>
  ))

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path={'/'}
        element={<BaseLayout />}
      >
        {renderRoutes(routes, true)}
      </Route>

      <Route
        path={'/'}
        element={<BaseLayout variant={'lesson'} />}
      >
        {renderRoutes(lessonLayoutRoutes, true)}
      </Route>

      <Route
        path={'/'}
        element={<AuthLayout />}
      >
        {renderRoutes([...registerRoutes, ...statusesRoutes], false)}
      </Route>

      <Route
        path={'/'}
        element={<EmptyLayout />}
      >
        {renderRoutes(signInRoute, false)}
        {renderRoutes(finishStaffRegisterRoutes, false)}
      </Route>

      <Route
        path="*"
        element={
          <Navigate
            to={'/'}
            replace
          />
        }
      />
    </>,
  ),
)

function App() {
  const cookies = new Cookies(null, { path: '/' })

  const { setAuth } = useActions()

  const token = cookies.get('accessToken')

  if (token) {
    setAuth(true)
  }

  return <RouterProvider router={router} />
}

export default App /* test comment */
